// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_tobenamed6 {
  background: var(--ColorPrimary);
  box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 10px;
  height: 30vh;
  width: 100%;
}

/***************************************Ecras pequenos (SmartPhones)***************************************/
@media only screen and (max-width: 600px) {
  .card_tobenamed6 {
    width: auto;
    height: 30%;
  }
}
/***************************************Ecras Grandes (PCs)***************************************/
@media only screen and (min-width: 600px) {
  .card_tobenamed6 {
    width: 63%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/toBeNamedCard6/toBeNamedCard6.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA,2GAA2G;AAC3G;EACE;IACE,WAAW;IACX,WAAW;EACb;AACF;AACA,kGAAkG;AAClG;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".card_tobenamed6 {\n  background: var(--ColorPrimary);\n  box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  padding: 10px;\n  height: 30vh;\n  width: 100%;\n}\n\n/***************************************Ecras pequenos (SmartPhones)***************************************/\n@media only screen and (max-width: 600px) {\n  .card_tobenamed6 {\n    width: auto;\n    height: 30%;\n  }\n}\n/***************************************Ecras Grandes (PCs)***************************************/\n@media only screen and (min-width: 600px) {\n  .card_tobenamed6 {\n    width: 63%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
